// extracted by mini-css-extract-plugin
module.exports = {"alternatives-inspector-content-container":"alternatives-inspector_alternatives-inspector-content-container__1-_Le"};